module.exports = __webpack_public_path__ + "static/image/company/pc/image_people@3x.jpg?9124dd54";